import { Card, Divider } from "semantic-ui-react";

import { Link } from "react-router-dom";

import TodoAssignedTo from "astrid-web/src/features/todos/components/Todos/components/TodoAssignedTo";

import TodoPinnedBy from "../../../../todos/components/Todos/components/TodoPinnedBy";

import NotificationContent from "./NotificationContent";
import NotificationDropdown from "./NotificationDropdown";
import NotificationHeader from "./NotificationHeader";
import NotificationProduction from "./NotificationProduction";

export default function Notification({ todo, organization }) {
	const { content, url, users, userNames } = todo;

	const showAssigned = organization && (users?.length > 0 || userNames?.length > 0);

	return (
		<Card as={Link} fluid style={{ borderRadius: 5, cursor: "pointer", color: "var(--color-text)" }} to={url}>
			<Card.Content>
				<NotificationHeader todo={todo} />

				<NotificationDropdown todo={todo} />

				{content && (
					<>
						<Divider style={{ margin: "10px 0" }} />
						<NotificationProduction todo={todo} />
						<NotificationContent todo={todo} />
					</>
				)}

				{showAssigned && <TodoAssignedTo todo={todo} />}

				{todo.pinned?.status && <TodoPinnedBy todo={todo} />}
			</Card.Content>
		</Card>
	);
}
